import { render, staticRenderFns } from "./GyNavigation.vue?vue&type=template&id=3012aca2&"
import script from "./GyNavigation.vue?vue&type=script&lang=js&"
export * from "./GyNavigation.vue?vue&type=script&lang=js&"
import style0 from "./GyNavigation.vue?vue&type=style&index=0&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports